<template>
  <div :class="isMobile ? 'join-m' : 'join'">
    <div class="word">
      <div class="word-title">加入我们</div>
      <div class="word-text">Join Us</div>
    </div>
    <div class="content">
      <el-collapse v-model="activeName" accordion class="content-part">
        <el-collapse-item v-for="(item, index) in jobList" :key="index" :name="index">
          <template slot="title">
            {{item.name}}
            <div class="job-sub-name">{{item.subName}}</div>
          </template>
          <div v-for="(obj, i) in item.contentList" :key="i">
            <div class="job-title">{{obj.title}}:</div>
            <div class="job-text">
              <p v-for="(one, sort) in obj.con" :key="sort">
                {{one}}
              </p>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="word">
      <div class="word-title">联系我们</div>
      <div class="word-text">Contact Us</div>
    </div>
    <div class="connect">
      <div class="connect-content">
        <el-row class="connect-row">
          <el-col :span="isMobile ? 24 : 12">
            <div class="connect-one connect-one-left">
              <div class="connect-one-title">
                <img  src="./../../assets/homeIcon/phone.png" />
                联系方式
              </div>
              <div class="connect-one-text">人才招聘：13668926940（微信同号）</div>
              <div class="connect-one-text">商务洽谈：15255615034（薛总）</div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 12" >
            <div class="connect-one">
              <div class="connect-one-title">
                <img  src="./../../assets/homeIcon/local.png" />
                公司地址
              </div>
              <div class="connect-one-text">地址：广东省佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMobile ? 24 : 12">
            <div class="connect-one connect-one-left">
              <div class="connect-one-title">
                <img  src="./../../assets/homeIcon/post.png" />
                邮箱邮编
              </div>
              <div class="connect-one-text">
                招聘邮箱：zengliming@aisensing.cn<br /><br />
                商务邮箱：xuefeng@aisensing.cn<br /><br />
                邮编：528000
              </div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 12" >
            <div class="connect-one">
              <div class="connect-one-title">
                <img src="./../../assets/homeIcon/service.png" />
                在线留言
              </div>
              <div class="connect-one-text">
                姓名<el-input class="inputInline" width="30%" v-model="username"></el-input> 
                电话<el-input class="inputInline" width="30%" v-model="userphone"></el-input><br />
                内容<el-input class="textareaInline" type="textarea" :rows="4" v-model="userText"></el-input>
                <span class="submitBox"><el-button type="primary" class="buttonInline" @click="submit">提交</el-button></span>
              </div>
            </div>
          </el-col>
        </el-row>
        <div id="map" style="height: 282px;" class="tMapBox"></div>
        <!-- <div class="connect-bottom">
            <div class="connect-bottom-title">艾感科技（广东）有限公司</div>
            <div class="connect-bottom-text">佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801</div>
        </div> -->
      </div>
    </div>
    <div class="word">
      <div class="word-title">快捷咨询</div>
      <div class="word-text">Quick Consultation</div>
    </div>
    <el-row class="quick-box">
      <el-col :span="8">
        <div class="connect-one">
          <img src="../../assets/homeIcon/phone.png" class="connect-one-img" />
          <span class="connect-one-text">15255615034</span>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="connect-one">
          <img src="../../assets/icon/taobao-empty.png" class="connect-one-img" />
          <span class="connect-one-text">
            <a href="https://shop503054747.taobao.com/?spm=pc_detail.30350276.shop_block.dshopinfo.4ccb1479InwI6i" target="_blank">
              淘宝商城
            </a>
          </span>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="connect-one">
          <img src="../../assets/homeIcon/wechat.png" class="connect-one-img" />
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="tpopover">
            <div>
              <img :src="imgUrl.codePer" />
            </div>
            <span class="connect-one-text" slot="reference">官方微信</span>
          </el-popover>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
  
<script>
  import Theme from "@/components/Theme.vue"
  import arrJson from '@/utils/arrJson'
  import imgUrl from "@/utils/imgUrl"

  export default {
    name: 'Join',
    components: {
      "Theme": Theme, //公司概况
    },
    data() {
      return {
        imgUrl,
        username: "",
        userphone: "",
        userText: "",
        isMobile: window.innerWidth < 780,
        activeName: 1,
        jobList: arrJson.jobList
      }
    },
    props: {
      msg: String
    },
    mounted() {
      window.addEventListener("resize", this.initFunc)
      this.setmap()
    },
    methods: {
      initFunc() {
        this.isMobile = window.innerWidth < 780
      },
      setmap(){
        var map = L.map('map').setView(L.latLng(23.0435205078125, 113.07627766927084), 17);
        L.tileLayer('/tile/{z}/{x}/{y}.png', {
          maxZoom: 19,
          maxNaticeZoom: 22
        }).addTo(map);
        var marker = L.marker([23.0435205078125, 113.07627766927084]).addTo(map);
        marker.bindPopup("<b class='map-title'>艾感科技（广东）有限公司</b><br><div class='map-subtitle'>佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801</div>",
        {maxWidth: 200}).openPopup();
      },
      submit() {
        if (this.isMobile) {
          if(this.username && this.userphone && this.userText) {
            isMobileNumber(this.userphone) ? this.submitRequest() : this.$dialog.alert({
              message: '请输入正确的手机号码',
            })
          } else {
            this.$dialog.alert({
                message: '请输入姓名和电话和留言后再提交',
            })
          }
        } else {
          if(this.username && this.userphone && this.userText) {
            isMobileNumber(this.userphone) ? this.submitRequest() : this.$message({
              message: '请输入正确的手机号码!',
              type: 'warning'
            });
          } else {
            this.$message({
              message: '请输入姓名和电话和留言后再提交!',
              type: 'warning'
            });
          }
        }
      },
      submitRequest(){
        request({
          url: "/device/airMessages",
          method: "post",
          data: {
            userName: this.username,
            telephone: this.userphone,
            remark: this.userText
          }
        }).then(res => {
          if(res.data.successful){
            if (this.isMobile) {
              this.$dialog.alert({
                message: '提交成功!',
              })
            }else{
              this.$message({
                message: '提交成功！',
                type: 'success'
              });
            }
          }
        }).catch((err) => {
          console.log("err", err)
        });
      },
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },
  }
  </script>
  
  
  <style scoped lang="less">
    /deep/.el-collapse-item__header{
      background: #f1f2f4;
      color: #00D0FF;
    }
    /deep/.el-collapse-item__wrap{
      background: #f1f2f4;
    }
    /deep/ .el-collapse{
        border: none;
    }
    /deep/ .el-icon-arrow-right:before {
      border: 1px solid;
      border-radius: 50%;
      font-size: 14px;
      padding: 2px;
    }
    .join{
      .word{
        margin-top: 40px;
        .word-title{
          line-height: 44px;
          font-size: 32px;
          margin-top: 60px;
          font-weight: bold;
          text-align: center;
          color: #313E47;
        }
        .word-text{
          color: #313E47;
          font-size: 16px;
          line-height: 26px;
          font-weight: normal;
          text-align: center;
          margin-bottom: 40px;
        }
      }
      .content{
        max-width: 1400px;
        margin: 0px auto 60px;
        .job-sub-name{
          display: block;
          font-size: 14px;
          color: #989898;
          margin-left: 20px;
        }
        /deep/.el-collapse-item{
          margin-bottom: 16px;
        }
        /deep/.el-collapse-item__header{
          padding: 0 46px;
          font-size: 18px;
          height: 60px;
        }
        /deep/.el-collapse-item__wrap{
          border-top: 1px dashed #becdf4;
          padding: 0 46px;
          font-size: 16px;
        }
        /deep/.el-collapse-item__content{
          .job-title{
            font-size: 18px;
            line-height: 20px;
            margin: 40px 0 14px;
          }
          .job-text{
            font-size: 14px;
            line-height: 28px;
          }
          p{
            margin: 0 0;
          }
        }
      }
      .connect{
        padding: 0 0 0;
        .connect-content{
          max-width: 1400px;
          margin: 0 auto 50px;
          .connect-row{
            margin-bottom: 20px;
          }
        }
        .word-title{
          line-height: 44px;
          font-size: 32px;
          margin-top: 60px;
          color: #1a1a1a;
          font-weight: bold;
          margin: 20px 0 50px;
          text-align: center;
        }
        .connect-one-left{
            margin-right: 20px;
        }
        .connect-one{
          text-align: left;
          background: #f1f2f4;
          padding: 36px 18px 7px 36px;
          min-height: 235px;
          .connect-one-title{
            color: #111312;
            font-size: 20px;
            margin-bottom: 24px;
            img{
              display: inline-block;
              vertical-align: middle;
              margin-right: 4px;
              width: 36px;
            }
          }
          .connect-one-text{
            color: #585453;
            line-height: 28px;
            .inputInline{
              vertical-align: top;
              display: inline-block;
              width: 28%;
              margin-right: 30px;
              margin-left: 6px;
              margin-bottom: 16px;
              border: 1px solid #bab4b4;
              border-radius: 6px;
              height: 38px;
            }
            .textareaInline{
              vertical-align: top;
              display: inline-block;
              width: 70%;
              margin-right: 30px;
              margin-left: 6px;
              border: 1px solid #bab4b4;
              border-radius: 6px;
            }
            .buttonInline{
              vertical-align: bottom;
              font-size: 14px;
              background: #00D0FF;
              padding: 10px 16px;
            }
          }
        }
        // .connect-bottom{
        //   padding: 20px 16px 50px 0;
        //   box-sizing: border-box;
        //   background: #FFFFFF;
        //   width: 100%;
        //   .connect-bottom-title{
        //     font-size: 18px;
        //     color: #000;
        //   }
        //   .connect-bottom-text{
        //     font-size: 14px;
        //     color: #232323;
        //     margin-top: 10px;
        //   }
        // }
      }
      .tMapBox{
        height: 278px;
        overflow: hidden;
        margin: 20px auto 0;
        .map-title{
          font-size: 14px;
          line-height: 30px;
        }
        .map-subtitle{
          font-size: 12px;
          line-height: 20px;
        }
      }
      .quick-box{
        max-width: 800px;
        margin: 40px auto;
        .connect-one{
          text-align: center;
          margin-bottom: 40px;
          .connect-one-img{
            width: 26px;
            height: 26px;
            display: inline-block;
            vertical-align: bottom;
            margin-right: 6px;
          }
          .connect-one-text{
            font-size: 20px;
          }
        }
      }
    }
    .join-m{
      .word{
        .word-title{
          font-size: 0.5rem;
          line-height: 0.6rem;
          font-weight: bold;
          color: #333333;
          letter-spacing: 0.05rem;
          margin: 0.4rem 0 0;
          text-align: center;
        }
        .word-text{
          font-size: 0.32rem;
          line-height: 0.6rem;
          color: #758292 ;
          text-align: center;
        }
      }
      .content{
        margin: 0.4rem 0.2rem;
        .job-sub-name{
          display: block;
          font-size: 0.28rem;
          color: #989898;
          margin-left: 0.4rem;
        }
        /deep/.el-collapse-item{
          margin-bottom: 0.4rem;
        }
        /deep/.el-collapse-item__header{
          padding: 0 0.3rem;
          font-size: 0.4rem;
          height: 1.2rem;
        }
        /deep/.el-collapse-item__wrap{
          border-top: 1px dashed #becdf4;
          padding: 0 0.4rem;
          font-size: 0.34rem;
        }
        /deep/.el-collapse-item__content{
          padding-bottom: 0.4rem;
          .job-title{
            font-size: 0.4rem;
            line-height: 0.5rem;
            color: #505052;
            margin: 0.8rem 0 0.3rem;
          }
          .job-text{
            font-size: 0.36rem;
            line-height: 0.6rem;
          }
          p{
            margin: 0 0;
          }
        }
      }
      .connect{
        padding: 1.2rem 0 0;
        .connect-content{
          margin: 0 auto 1rem;
          .connect-row{
            margin-bottom: 0.06rem;
          }
        }
        .connect-one{
          text-align: left;
          background: #f3f4f9;
          padding: 0.8rem 0.8rem 0.2rem 0.8rem;
          margin: 0.2rem;
          .connect-one-title{
            color: #111312;
            font-size: 0.46rem;
            margin-bottom: 0.5rem;
            img{
              display: inline-block;
              vertical-align: middle;
              margin-right: 0.1rem;
            }
          }
          .connect-one-text{
            color: #585453;
            line-height: 0.7rem;
            margin-bottom: 0.7rem;
            font-size: 0.4rem;
            .inputInline{
              display: inline-block;
              width: 85%;
              margin-left: 0.3rem;
              margin-bottom: 0.4rem;
            }
            .textareaInline{
              vertical-align: top;
              display: inline-block;
              width: 85%;
              margin-left: 0.3rem;
            }
            .submitBox{
              display: block;
              width: 100%;
              text-align: right;
            }
            .buttonInline{
              font-size: 0.36rem;
              background: #00D0FF;
              padding: 0.24rem 0.4rem;
              margin-top: 0.4rem;
            }
          }
        }
        // .connect-bottom{
        //   padding: 0.66rem 0.2rem 1.6rem 0.2rem;
        //   box-sizing: border-box;
        //   background: #FFFFFF;
        //   width: 100%;
        //   .connect-bottom-title{
        //     font-size: 0.46rem;
        //     color: #000;
        //   }
        //   .connect-bottom-text{
        //     font-size: 0.36rem;
        //     color: #232323;
        //     margin-top: 10px;
        //   }
        // }
      }
      .tMapBox{
        height: 2.8rem;
        overflow: hidden;
        margin: 1rem auto 0;
        /deep/.leaflet-popup-content{
          width: 5rem !important;
        }
        /deep/.map-title{
          font-size: 0.38rem;
        }
        /deep/.map-subtitle{
          font-size: 0.3rem;
        }
      }
      .quick-box{
        width: 90%;
        margin: 0 auto 1rem;
        font-size: 0.26rem;
        .connect-one{
          text-align: center;
        }
        .connect-one-img{
          width: 0.6rem;
          vertical-align: middle;
        }
      }
    }
  
  </style>
  